import React, { useState } from 'react';
import './DeleteConfirmationModal.css';

/**
 * Shared across products, categories and subcategories, so the noun is a prop.
 * `productName` is kept as the name prop because both existing call sites use
 * it; `itemType` defaults to "product" so nothing changes for them.
 */
const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, productName, itemType = 'product' }) => {
  const [reason, setReason] = useState('');
  // Field-level validation, not a notification: the message belongs next to the
  // input it's about, announced with it, rather than in a toast across the screen.
  const [error, setError] = useState('');

  if (!isOpen) {
    return null;
  }

  const handleConfirm = () => {
    if (!reason.trim()) {
      setError('Please give a reason before deleting.');
      return;
    }
    setError('');
    onConfirm(reason);
  };

  return (
    <div className="delete-modal-overlay" onClick={onClose}>
      <div className="delete-modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>Confirm Deletion</h2>
        <p>
          Are you sure you want to delete the {itemType}: <strong>{productName}</strong>?
        </p>
        <div className="form-group">
          <label htmlFor="deleteReason">Reason for Deletion</label>
          <textarea
            id="deleteReason"
            value={reason}
            onChange={(e) => { setReason(e.target.value); if (error) setError(''); }}
            placeholder="Please provide a reason..."
            rows="3"
            aria-invalid={error ? 'true' : undefined}
            aria-describedby={error ? 'deleteReasonError' : undefined}
          />
          {error && (
            <p id="deleteReasonError" className="delete-modal-error" role="alert">
              {error}
            </p>
          )}
        </div>
        <div className="modal-actions">
          <button onClick={onClose} className="btn-cancel">
            Cancel
          </button>
          <button onClick={handleConfirm} className="btn-confirm-delete">
            Confirm Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;